var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"auth-alert h-auto rounded-5 d-flex justify-content-start align-items-center text-left",class:_vm.alert_class},[_vm._v(" "+_vm._s(_vm.alert_msg)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }